import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#90B9FF"
      d="M1 4.263A1.27 1.27 0 0 1 2.277 3h3.194c.352 0 .638.283.638.632"
      opacity={0.2}
    />
    <path
      fill="url(#Folder-Light_svg__a)"
      d="M1.878 6.706a1.27 1.27 0 0 1 1.275-1.18h10.532a1.27 1.27 0 0 1 1.275 1.348l-.469 6.947A1.27 1.27 0 0 1 13.217 15H2.685a1.27 1.27 0 0 1-1.275-1.348z"
    />
    <path
      fill="#23F6E7"
      d="M2.368 7.769c.133-.573.65-.98 1.244-.98h11.11c.82 0 1.429.756 1.244 1.548L14.64 14.02c-.134.573-.65.98-1.245.98H2.285c-.82 0-1.429-.757-1.244-1.548z"
    />
    <defs>
      <linearGradient
        id="Folder-Light_svg__a"
        x1={8.185}
        x2={8.185}
        y1={5.526}
        y2={15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.5} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFolderLight;
